<ng-container *ngIf="showContentCard">
  <div *ngIf="!absolutePosition" class="no-content no-content--default">
    <div class="no-content__image">
      <img src="../../../../../assets/images/no-content.png" />
    </div>
    <p class="no-content__message">{{ text }}</p>
  </div>

  <div
    class="no-content--absolute no-content--default"
    *ngIf="absolutePosition"
  >
    <mat-card class="mat-elevation-z5">
      <div class="card__content">
        <div class="no-content__image">
          <img src="../../../../../assets/images/no-content.png" />
        </div>
        <p class="no-content__message">{{ text }}</p>
      </div>
    </mat-card>
  </div>
</ng-container>
